{
  "a": "una",
  "an": "un",
  "Account": "Cuenta",
  "AccountSettings": "Ajustes de Cuenta",
  "changeAccountSettings": "Cambia tus ajustes básicos",
  "notVerified": "Sin verificar",
  "Verified": "Verificado",
  "AlternateEmail": "Email alternativo",
  "NoAlternateEmail": "No tienes emails alternativos.",
  "changeRole": "Cambiar rol",
  "LeaveProject": "Dejar proyecto",
  "NoActionPhrase1": "No hay ninguna acción que puedas realizar por sí mismo. Para realizar modificaciones, consulta tu",
  "accountSettings": "ajustes de cuenta",
  "NoActionPhrase2": "No hay ninguna acción para realizar ",
  "save": "Guardar",
  "Title": "Título",
  "editTitle": "editar título",
  "DangerZone": "Zona peligrosa",
  "Delete": "Eliminar ",
  "DeleteWarning": "Una vez que elimines este proyecto, NO hay vuelta atrás. Por favor, asegúrate",
  "DeleteProjectButton": "Eliminar este proyecto",
  "Hub": "Hub",
  "Project": "Proyecto",
  "ManageTeam": "Dirigir equipo",
  "Team": "Equipo",
  "ManageTeamPhrase1Part1": "Eres ",
  "ManageTeamPhrase1Part2": "de este proyecto",
  "ManageTeamPhrase2Part1": "Para agregar un miembro del equipo, ",
  "clickHere": " haz clic aquí",
  "PendingInvitations": "Invitaciones pendientes",
  "resendInvite": "Reenviar invitación",
  "NoPendingInvitations": "Sin invitacion pendientes",
  "Primary": "Principal",
  "verify": "Verificar",
  "MakePrimary": "Hacer principal",
  "remove": "Eliminar",
  "EmailAddress": "Dirección de correo electrónico",
  "addEmail": "Agregar correo electrónico",
  "addHubAdmin": "Para añadir a un administrador de hub,",
  "ProjectNameAlreadyExists": "Oh vaya! Este nombre de proyecto ya está en uso. Seleccione otro nombre. Bueno, ¡es otra oportunidad para ser creativo!",
  "ConfirmProjectDeletion": "¿Estás seguro de que deseas eliminar este Proyecto?",
  "SubscriptionExpired": "¡Esta suscripción ha caducado!",
  "SubscriptionExpiredMessage": "Tu acceso al hub ahora es limitado. Por favor renueve poniéndose en contacto con nosotros.",
  "FirstChoice": "Contacta con nosotros",
  "Cancel": "Cancelar",
  "firstName": "Nombre",
  "lastName": "Apellidos",
  "Purpose": "Propósito",
  "Location": "Ubicación",
  "LocationPlaceholder": "Busca tu ciudad aquí",
  "Stage": "Etapa",
  "Seed": "Semilla",
  "Planning": "Planificación",
  "Startup": "Puesta en marcha",
  "Growth": "Crecimiento",
  "Mature": "Maduro",
  "noTitle": "Sin título todavía",
  "Name": "Nombre",
  "Role": "Rol",
  "DeleteAccountHeading": "Eliminar tu cuenta",
  "DeleteAccountButton": "Eliminar cuenta",
  "DeleteAccountWarning": "Al eliminar tu cuenta se cerrará tu sesión en todos los dispositivos de inmediato. Después de 30 días borraremos permanentemente tu información personal: tu nombre, direcciones de correo, perfil, imágenes subidas y registros de actividad. Esto no se puede deshacer.",
  "DeleteAccountDialogTitle": "¿Eliminar tu cuenta?",
  "DeleteAccountDialogWarning": "Tu cuenta se desactivará de inmediato y se borrará permanentemente después de 30 días. Escribe a support@rebelbase.co antes de esa fecha si cambias de opinión.",
  "DeleteAccountConfirmPrompt": "Escribe {{confirmation}} para confirmar.",
  "DeleteAccountConfirmButton": "Eliminar mi cuenta",
  "DeleteAccountError": "No pudimos procesar la solicitud. Inténtalo de nuevo o escribe a support@rebelbase.co.",
  "Profile": "Perfil",
  "NameRequired": "Este campo es obligatorio.",
  "ProjectIdentityTitle": "Identidad del proyecto",
  "ProjectIdentityDescription": "Cómo aparecen el logo y el nombre de tu proyecto en RebelBase.",
  "Replace": "Reemplazar",
  "LogoHint": "JPG, PNG o GIF, hasta 5 MB.",
  "ProjectDetailsTitle": "Detalles del proyecto",
  "ProjectDetailsDescription": "La industria, la etapa y la visibilidad de búsqueda de tu proyecto.",
  "GeneralTab": "General",
  "MembersAndRolesTab": "Miembros y roles",
  "ProjectSettingsTabsLabel": "Secciones de configuración del proyecto",
  "NoChangesYet": "Sin cambios",
  "UnsavedChanges": "Cambios sin guardar",
  "AllChangesSaved": "Todos los cambios guardados",
  "SaveChanges": "Guardar cambios",
  "MaxPhotoSize": "Gran foto, pero superó el tamaño máximo: 5 MB.",
  "SupportedFormats": "El formato de imagen no es compatible. Los formatos admitidos son jpg, jpeg, png, gif y jfif.",
  "memberActions": "Acciones del miembro",
  "RemoveFromProject": "Quitar del proyecto",
  "RemoveMemberDialogTitle": "Quitar miembro",
  "RemoveMemberDialogWarning": "{{name}} perderá el acceso a este proyecto de inmediato. Lo que haya escrito permanece en el proyecto.",
  "RemoveMemberPeerHint": "No puedes quitar a un miembro con tu mismo nivel de rol o superior.",
  "RemoveMemberOwnerHint": "No se puede quitar a los propietarios. Primero asígnales un rol inferior.",
  "MemberRemoved": "{{name}} fue quitado del proyecto.",
  "MemberRemovedGroups": "El proyecto también salió de: {{groups}}.",
  "RemoveMemberError": "No se pudo quitar a ese miembro. Inténtalo de nuevo.",
  "LeaveProjectDialogTitle": "Dejar proyecto",
  "LeaveProjectDialogWarning": "Perderás el acceso a este proyecto de inmediato.",
  "LeaveProjectLastMemberHint": "Eres el único miembro, así que no puedes salir. Elimina el proyecto en su lugar.",
  "leave": "Salir",
  "RemoveMemberConfirm": "Quitar",
  "AccountSettingsSubtitle": "Gestiona tu nombre, tu acceso y las notificaciones por correo.",
  "AccountSettingsTabsLabel": "Secciones de configuración de la cuenta",
  "NotificationsTab": "Notificaciones",
  "ProfileSectionDescription": "Tu nombre y dónde te encuentras.",
  "PublicProfileLink": "La foto, la biografía y la visibilidad están en tu perfil público",
  "EmailAddressDescription": "Cómo te contactamos. Los cambios aquí se aplican de inmediato.",
  "RemoveEmailDialogTitle": "¿Eliminar esta dirección de correo?",
  "RemoveEmailDialogWarning": "Dejarás de recibir correo en {{email}}. Puedes añadirla de nuevo más adelante, pero habrá que verificarla otra vez.",
  "RemoveEmailConfirmButton": "Eliminar correo",
  "DangerZoneDescription": "Eliminar tu cuenta es permanente una vez que terminen los 30 días de gracia.",
  "EmailNotificationsDescription": "Con qué frecuencia te enviamos un resumen de lo que ha pasado."
}
